import Vue from "vue";
import { i18n } from "./config/languages/i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Pipes
import "./pipes/DatePipes";

// BootstrapCSS Configuration
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "./main.scss";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import DialogConfirmDelete from "./components/controls/DialogConfirmDelete.vue";
import DialogConfirm from "./components/controls/DialogConfirm.vue";
import DialogPaymentResult from "./components/controls/DialogPaymentResult.vue";
import DialogPaymentOptionsConfirm from "./components/controls/DialogPaymentOptionsConfirm.vue";

import FormBuilder from "../../Breeze.FormBuilder.Frontend/plugins/formBuilder";
import mixins from "./plugins/mixins";
import Directives from "./plugins/directives";
import InputFacade from "vue-input-facade";
import VueSignaturePad from "vue-signature-pad";

import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import "fontawesome-4.7";
import "./assets/fa6/css/all.css";

import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import sessionService from "./server/session";
import { setToken as setTokenFB } from "../../Breeze.FormBuilder.Frontend/helpers/session";

import sanitizeHtml from "sanitize-html";
import sanitizeOptions from "./config/sanitize";

import Filters from "./plugins/filters";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetalert2);

Vue.use(FormBuilder);
Vue.use(mixins);
Vue.use(Directives);
Vue.use(InputFacade);
Vue.use(VueSignaturePad);

Vue.use(Filters);

Vue.use(VueTelInput);

Vue.use(VuejsDialog);

Vue.component("v-select", vSelect);

Vue.dialog.registerComponent("confirm-delete", DialogConfirmDelete);
Vue.dialog.registerComponent("confirm", DialogConfirm);
Vue.dialog.registerComponent("payment-result", DialogPaymentResult);
Vue.dialog.registerComponent(
  "payment-options-confirm",
  DialogPaymentOptionsConfirm
);

Vue.prototype.$sanitize = function(html) {
  return sanitizeHtml(html, sanitizeOptions);
};

new Vue({
  i18n,
  store,
  router,
  render: h => h(App),
  created() {
    if (sessionService.isLogged()) {
      setTokenFB(sessionService.session().token);
    }
  }
}).$mount("#app");
